import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const getAllCountryOfProjectImplementation = createAsyncThunk(
  "dropdowns/getAllCountryOfProjectImplementation",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllIP_CountryOfProjectImplementation"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAI_SubSector = createAsyncThunk(
  "dropdowns/GetAllAI_SubSector",
  async (AI_MainSectorId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `api/DropDowns/GetAllAI_SubSector?AI_MainSectorId=${AI_MainSectorId}`
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAI_SecondarySectors = createAsyncThunk(
  "dropdowns/GetAllAI_SecondarySectors",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllAI_SecondarySectors"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetAllAI_SupportProgramsName = createAsyncThunk(
  "dropdowns/GetAllAI_SupportProgramsName",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllAI_SupportProgramsName"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetAllAI_GrantsProgram = createAsyncThunk(
  "dropdowns/GetAllAI_GrantsProgram",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `api/DropDowns/GetAllAI_GrantsProgram`
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAI_MainSector = createAsyncThunk(
  "dropdowns/GetAllAI_MainSector",
  async (AI_GrantsProgramId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `api/DropDowns/GetAllAI_MainSector?AI_GrantsProgramId=${AI_GrantsProgramId}`
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAI_Nationality = createAsyncThunk(
  "dropdowns/GetAllAI_Nationality",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllAI_Nationality"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAI_CountryOfResidence = createAsyncThunk(
  "dropdowns/GetAllAI_CountryOfResidence",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllAI_CountryOfResidence"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAI_Governorate = createAsyncThunk(
  "dropdowns/GetAllAI_Governorate",
  async (AI_CountryOfResidenceId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `api/DropDowns/GetAllAI_Governorate?AI_CountryOfResidenceId=${AI_CountryOfResidenceId}`
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAI_ApplicantType = createAsyncThunk(
  "dropdowns/GetAllAI_ApplicantType",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllAI_ApplicantType"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAI_NatureOfSupport = createAsyncThunk(
  "dropdowns/GetAllAI_NatureOfSupport",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllAI_NatureOfSupport"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllbI_ImplementationDurationMonths = createAsyncThunk(
  "dropdowns/GetAllbI_ImplementationDurationMonths",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllbI_ImplementationDurationMonths"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAC_findOutAwardNames = createAsyncThunk(
  "dropdowns/GetAC_findOutAwardNames",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAC_findOutAwardNames"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllActiveAI_MainSector = createAsyncThunk(
  "dropdowns/GetAllActiveAI_MainSector",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllActiveAI_MainSector"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const DropDownApplicationInformation = createSlice({
  name: "DropDownApplicationInformation",
  initialState: {
    countryOfProjectImplementation: [],
    loadingCountryOfProjectImplementation: false,
    errorCountryOfProjectImplementation: null,
    //--------------------SubSector---------------------
    SubSector: [],
    loadingSubSector: false,
    errorSubSector: null,
    //--------------------SupportProgramsName---------------------
    SupportProgramsName: [],
    loadingSupportProgramsName: false,
    errorSupportProgramsName: null,
    //--------------------AI_MainSector---------------------
    AI_MainSector: [],
    loadingAI_MainSector: false,
    errorAI_MainSector: null,
    //--------------------AI_Nationality---------------------
    AI_Nationality: [],
    loadingAI_Nationality: false,
    errorAI_Nationality: null,
    //--------------------AI_CountryOfResidence---------------------
    AI_CountryOfResidence: [],
    loadingAI_CountryOfResidence: false,
    errorAI_CountryOfResidence: null,
    //--------------------AI_Governorate---------------------
    AI_Governorate: [],
    loadingAI_Governorate: false,
    errorAI_Governorate: null,
    //--------------------AI_ApplicantType---------------------
    AI_ApplicantType: [],
    loadingAI_ApplicantType: false,
    errorAI_ApplicantType: null,
    //--------------------AI_NatureOfSupport---------------------
    AI_NatureOfSupport: [],
    loadingAI_NatureOfSupport: false,
    errorAI_NatureOfSupport: null,
    //--------------------AI_GrantsProgram---------------------
    AI_GrantsProgram: [],
    loadingAI_GrantsProgram: false,
    errorAI_GrantsProgram: null,

    //--------------------bI_ImplementationDurationMonths---------------------
    bI_ImplementationDurationMonths: [],
    loadingbI_ImplementationDurationMonths: false,
    errorbI_ImplementationDurationMonths: null,

    //--------------------GetAC_findOutAwardNames---------------------
    AC_findOutAwardNames: [],
    loadingAC_findOutAwardNames: false,
    errorAC_findOutAwardNames: null,
    //--------------------GetAllActiveAI_MainSector---------------------
    AllActiveAI_MainSector: [],
    loadingAllActiveAI_MainSector: false,
    errorAllActiveAI_MainSector: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        getAllCountryOfProjectImplementation.pending,
        (state, action) => {
          state.loadingCountryOfProjectImplementation = true;
          state.countryOfProjectImplementation = action.payload;
          state.errorCountryOfProjectImplementation = null;
        }
      )
      .addCase(
        getAllCountryOfProjectImplementation.fulfilled,
        (state, action) => {
          state.loadingCountryOfProjectImplementation = false;
          state.countryOfProjectImplementation = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        getAllCountryOfProjectImplementation.rejected,
        (state, action) => {
          state.loadingCountryOfProjectImplementation = false;
          state.errorCountryOfProjectImplementation = action.payload;
        }
      )

      //--------------------SubSector---------------------

      .addCase(GetAllAI_SubSector.pending, (state, action) => {
        state.loadingSubSector = true;
        state.SubSector = action.payload;
        state.errorSubSector = null;
      })
      .addCase(GetAllAI_SubSector.fulfilled, (state, action) => {
        state.loadingSubSector = false;
        state.SubSector = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAI_SubSector.rejected, (state, action) => {
        state.loadingSubSector = false;
        state.errorSubSector = action.payload;
      })
      //--------------------SupportProgramsName---------------------

      .addCase(GetAllAI_SupportProgramsName.pending, (state, action) => {
        state.loadingSupportProgramsName = true;
        state.SupportProgramsName = action.payload;
        state.errorSupportProgramsName = null;
      })
      .addCase(GetAllAI_SupportProgramsName.fulfilled, (state, action) => {
        state.loadingSupportProgramsName = false;
        state.SupportProgramsName = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAI_SupportProgramsName.rejected, (state, action) => {
        state.loadingSupportProgramsName = false;
        state.errorSupportProgramsName = action.payload;
      })

      //--------------------AI_MainSector---------------------

      .addCase(GetAllAI_MainSector.pending, (state, action) => {
        state.loadingAI_MainSector = true;
        state.AI_MainSector = action.payload;
        state.errorAI_MainSector = null;
      })
      .addCase(GetAllAI_MainSector.fulfilled, (state, action) => {
        state.loadingAI_MainSector = false;
        state.AI_MainSector = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAI_MainSector.rejected, (state, action) => {
        state.loadingAI_MainSector = false;
        state.errorAI_MainSector = action.payload;
      })

      //--------------------AI_Nationality---------------------

      .addCase(GetAllAI_Nationality.pending, (state, action) => {
        state.loadingAI_Nationality = true;
        state.AI_Nationality = action.payload;
        state.errorAI_Nationality = null;
      })
      .addCase(GetAllAI_Nationality.fulfilled, (state, action) => {
        state.loadingAI_Nationality = false;
        state.AI_Nationality = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAI_Nationality.rejected, (state, action) => {
        state.loadingAI_Nationality = false;
        state.errorAI_Nationality = action.payload;
      })
      //--------------------AI_CountryOfResidence---------------------

      .addCase(GetAllAI_CountryOfResidence.pending, (state, action) => {
        state.loadingAI_CountryOfResidence = true;
        state.AI_CountryOfResidence = action.payload;
        state.errorAI_CountryOfResidence = null;
      })
      .addCase(GetAllAI_CountryOfResidence.fulfilled, (state, action) => {
        state.loadingAI_CountryOfResidence = false;
        state.AI_CountryOfResidence = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAI_CountryOfResidence.rejected, (state, action) => {
        state.loadingAI_CountryOfResidence = false;
        state.errorAI_CountryOfResidence = action.payload;
      })

      //--------------------AI_Governorate---------------------

      .addCase(GetAllAI_Governorate.pending, (state, action) => {
        state.loadingAI_Governorate = true;
        state.AI_Governorate = action.payload;
        state.errorAI_Governorate = null;
      })
      .addCase(GetAllAI_Governorate.fulfilled, (state, action) => {
        state.loadingAI_Governorate = false;
        state.AI_Governorate = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAI_Governorate.rejected, (state, action) => {
        state.loadingAI_Governorate = false;
        state.errorAI_Governorate = action.payload;
      })
      //--------------------AI_ApplicantType---------------------

      .addCase(GetAllAI_ApplicantType.pending, (state, action) => {
        state.loadingAI_ApplicantType = true;
        state.AI_ApplicantType = action.payload;
        state.errorAI_ApplicantType = null;
      })
      .addCase(GetAllAI_ApplicantType.fulfilled, (state, action) => {
        state.loadingAI_ApplicantType = false;
        state.AI_ApplicantType = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAI_ApplicantType.rejected, (state, action) => {
        state.loadingAI_ApplicantType = false;
        state.errorAI_ApplicantType = action.payload;
      })

      //--------------------AI_NatureOfSupport---------------------

      .addCase(GetAllAI_NatureOfSupport.pending, (state, action) => {
        state.loadingAI_NatureOfSupport = true;
        state.AI_NatureOfSupport = action.payload;
        state.errorAI_NatureOfSupport = null;
      })
      .addCase(GetAllAI_NatureOfSupport.fulfilled, (state, action) => {
        state.loadingAI_NatureOfSupport = false;
        state.AI_NatureOfSupport = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAI_NatureOfSupport.rejected, (state, action) => {
        state.loadingAI_NatureOfSupport = false;
        state.errorAI_NatureOfSupport = action.payload;
      })
      //--------------------AI_GrantsProgram---------------------

      .addCase(GetAllAI_GrantsProgram.pending, (state, action) => {
        state.loadingAI_GrantsProgram = true;
        state.AI_GrantsProgram = action.payload;
        state.errorAI_GrantsProgram = null;
      })
      .addCase(GetAllAI_GrantsProgram.fulfilled, (state, action) => {
        state.loadingAI_GrantsProgram = false;
        state.AI_GrantsProgram = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAI_GrantsProgram.rejected, (state, action) => {
        state.loadingAI_GrantsProgram = false;
        state.errorAI_GrantsProgram = action.payload;
      })

      //--------------------bI_ImplementationDurationMonths---------------------

      .addCase(
        GetAllbI_ImplementationDurationMonths.pending,
        (state, action) => {
          state.loadingbI_ImplementationDurationMonths = true;
          state.bI_ImplementationDurationMonths = action.payload;
          state.errorbI_ImplementationDurationMonths = null;
        }
      )
      .addCase(
        GetAllbI_ImplementationDurationMonths.fulfilled,
        (state, action) => {
          state.loadingbI_ImplementationDurationMonths = false;
          state.bI_ImplementationDurationMonths = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetAllbI_ImplementationDurationMonths.rejected,
        (state, action) => {
          state.loadingbI_ImplementationDurationMonths = false;
          state.errorbI_ImplementationDurationMonths = action.payload;
        }
      )

      //--------------------AC_findOutAwardNames---------------------

      .addCase(GetAC_findOutAwardNames.pending, (state, action) => {
        state.loadingAC_findOutAwardNames = true;
        state.AC_findOutAwardNames = action.payload;
        state.errorAC_findOutAwardNames = null;
      })
      .addCase(GetAC_findOutAwardNames.fulfilled, (state, action) => {
        state.loadingAC_findOutAwardNames = false;
        state.AC_findOutAwardNames = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAC_findOutAwardNames.rejected, (state, action) => {
        state.loadingAC_findOutAwardNames = false;
        state.errorAC_findOutAwardNames = action.payload;
      })

      //--------------------GetAllActiveAI_MainSector---------------------

      .addCase(GetAllActiveAI_MainSector.pending, (state, action) => {
        state.loadingAllActiveAI_MainSector = true;
        state.AllActiveAI_MainSector = action.payload;
        state.errorAllActiveAI_MainSector = null;
      })
      .addCase(GetAllActiveAI_MainSector.fulfilled, (state, action) => {
        state.loadingAllActiveAI_MainSector = false;
        state.AllActiveAI_MainSector = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllActiveAI_MainSector.rejected, (state, action) => {
        state.loadingAllActiveAI_MainSector = false;
        state.errorAllActiveAI_MainSector = action.payload;
      });
  },
});

export default DropDownApplicationInformation.reducer;
